<template>
    <div class="block cursor-pointer" @click="$emit('click')">
        <div class="inline-block align-middle" :class="{'sprite-icons-minus': show, 'sprite-icons-plus': !show}"></div>
        <div class="inline-block px-1">{{ text }}</div>
    </div>
</template>
<script>
export default {
    props: {
        show: Boolean,
        text: String
    }
}
</script>